const supportedLocales = [
  { id: 'en', title: 'English', isDefault: true },
  { id: 'es', title: 'Spanish' },
  { id: 'pt', title: 'Portuguese' },
  { id: 'fr', title: 'French' },
  { id: 'de', title: 'German' },
  { id: 'it', title: 'Italian' },
];

const defaultLocale = 'en';

const rootPath = ['/'];

const rootPathsByLocale = rootPath
  .concat(supportedLocales.map((locale) => `/${locale.id}`))
  .concat(supportedLocales.map((locale) => `/${locale.id}/`));

const chdTvSearchPageSlug = '/chd-tv/search';

const QUERY_IDS = {
  BECOME_INSIDER_ID: 'become-insider',
  MILLION_MATCH_QUERY_ID: 'million-match',
  THE_PEOPLES_STUDY_QUERY_ID: 'the-peoples-study',
};

const chdTvSearchPageSlugsArray = supportedLocales.map((locale): any => {
  const chdTvLocaleSlug = locale.id === 'en' ? chdTvSearchPageSlug : `/${locale.id}${chdTvSearchPageSlug}`;
  return chdTvLocaleSlug;
});

const ShowEventSections: Record<string, string> = {
  ShowHome: 'Show Home',
  EventHome: 'Event Home',
  About: 'About',
  All: 'All',
};

export {
  chdTvSearchPageSlug,
  chdTvSearchPageSlugsArray,
  defaultLocale,
  rootPath,
  rootPathsByLocale,
  ShowEventSections,
  supportedLocales,
  QUERY_IDS,
};
